//公共工具函數
import httpClient from './request.js';
const http = httpClient.http
//按应用模块获取对应的标签
//  dicMatValue 应用模块   SonValue 对应标签名称  pid 标签id
var getGroupList = (dicMatValue = '', SonValue = '', pid = -1) => {
	return new Promise((resolve, resject) => {
		var url = `/api/source/matDic/selectByParentId?pid=${pid}&dicMatValue=${dicMatValue}`
		http.get(url, {}).then(res => {
			if (SonValue == '') {
				resolve(res.data.data) //返回满足条件的所有父标签集合
			} else {
				let list = res.data.data
				let index = list.findIndex(item => item.dicDesc == SonValue)
				if (index != -1) {
					getGroupList('', '', list[index].dicId)
						.then(result => {
							resolve(result) //返回满足条件的第一个子标签下的所有集合
						})
				} else {
					resolve(res.data.data) //返回满足条件的所有父标签集合
				}
			}
		}).finally(res => {});
	})
}

export {
	getGroupList
}
